module.exports = __webpack_public_path__ + "img/SLS-PrimaryHoriz-Fire.762480b8.svg";